// src/components/JobsDashboard.js

import React, { useState, useEffect, useCallback } from 'react'
import { adminService } from '../services/admin.service'
import { JobForm } from './control-jobs-form'

export function ControlJobs() {
    const [initialJobs, setInitialJobs] = useState([])
    const [jobs, setJobs] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isSaving, setIsSaving] = useState(false)

    const [isFormOpen, setIsFormOpen] = useState(false)
    const [jobToEdit, setJobToEdit] = useState(null)

    // Fetch initial data on component mount
    useEffect(() => {
        setIsLoading(true)
        adminService.getJobs()
            .then(data => {
                setJobs(data)
                // Store a deep copy for the "restore" functionality
                setInitialJobs(JSON.parse(JSON.stringify(data)))
            })
            .catch(console.error)
            .finally(() => setIsLoading(false))
    }, [])

    const handleOpenFormForCreate = () => {
        setJobToEdit(null) // No job to edit means "create mode"
        setIsFormOpen(true)
    }

    const handleOpenFormForEdit = (job) => {
        setJobToEdit(job)
        setIsFormOpen(true)
    }

    const handleCloseForm = () => {
        setIsFormOpen(false)
        setJobToEdit(null)
    }

    const handleSaveJob = useCallback((savedJob) => {
        if (savedJob._id) { // Editing an existing job
            setJobs(prevJobs =>
                prevJobs.map(job => job._id === savedJob._id ? savedJob : job)
            )
        }
        else {
            const newJob = { ...savedJob, _id: `job_${Date.now()}` }
            setJobs(prevJobs => [newJob, ...prevJobs])
        }
        handleCloseForm()
    }, [])

    const handleDeleteJob = (jobId) => {
        if (window.confirm('האם אתה בטוח שברצונך למחוק משרה זו?')) {
            setJobs(prevJobs => prevJobs.filter(job => job._id !== jobId))
        }
    }

    const handleGlobalSave = async () => {
        setIsSaving(true)
        try {
            await adminService.editJobs(jobs)
            setInitialJobs(JSON.parse(JSON.stringify(jobs)))
        } catch (error) {
            console.error("Failed to save jobs:", error)
            alert("שגיאה בשמירת הנתונים לשרת.")
        } finally {
            setIsSaving(false)
        }
    }

    const handleRestoreDefault = () => {
        if (window.confirm('פעולה זו תבטל את כל השינויים שבוצעו. להמשיך?')) {
            setJobs(JSON.parse(JSON.stringify(initialJobs)))
        }
    }

    if (isLoading) {
        return <div className="loading-state">טוען נתונים...</div>
    }

    return (
        <div className="dashboard-container">
            <header className="dashboard-header">
                <h1>לוח בקרת משרות</h1>
                <div className="header-actions">
                    <button onClick={handleOpenFormForCreate} className="btn-add">
                        + הוסף משרה חדשה
                    </button>
                    <button onClick={handleRestoreDefault} className="btn-restore">
                        שחזר לגרסה השמורה
                    </button>
                    <button onClick={handleGlobalSave} className="btn-save" disabled={isSaving}>
                        {isSaving ? 'שומר...' : 'שמור שינויים'}
                    </button>
                </div>
            </header>

            <main className="jobs-list">
                {jobs.map(job => (
                    <div key={job._id} className="job-card">
                        <img src={job.img} alt={job.title} className="job-card-img" />
                        <div className="job-card-content">
                            <h3>{job.title}</h3>
                            <p>{job.description.substring(0, 100)}...</p>
                            <div className="job-card-actions">
                                <button onClick={() => handleOpenFormForEdit(job)}>ערוך</button>
                                <button onClick={() => handleDeleteJob(job._id)} className="btn-delete">מחק</button>
                            </div>
                        </div>
                    </div>
                ))}
                {jobs.length === 0 && <p className="no-jobs-message">לא נמצאו משרות. אפשר להתחיל להוסיף!</p>}
            </main>

            {isFormOpen && (
                <JobForm
                    jobToEdit={jobToEdit}
                    onSave={handleSaveJob}
                    onClose={handleCloseForm}
                />
            )}
        </div>
    )
}